module.exports = __webpack_public_path__ + "media/images/common/normal_product_menu-b7bf9d54b39669bc5eb75e7f1745ac2c.png";